// CustomSelect.js
import React from 'react';
import Select from 'react-select';
import './styles.scss';

const DropDownBox = ({ options, placeholder, onChange, value, customStyles, disabled = false }) => {


  return (
    <Select
      styles={customStyles}
      options={options}
      placeholder={placeholder}
      onChange={onChange}
      value={value}
      components={{
        IndicatorSeparator: () => null
      }}
      isDisabled={disabled}
    />
  );
};

export default DropDownBox;
